import './InlineAlert.scss';
import { TextWithIcon } from 'app/agriculture/components/TextWithIcon/TextWithIcon';
import { AgricultureToastType } from 'app/agriculture/AgricultureToast/agriculture_toast_service';
import { ToastIcon } from 'app/agriculture/AgricultureToast/components/ToastContent/ToastIcon';
import classNames from 'classnames';
import { RefCallBack } from 'react-hook-form';

interface InlineAlertProps {
    children: string;
    type: AgricultureToastType;
    ref?: RefCallBack;
}

export function InlineAlert({ children, type, ref }: InlineAlertProps) {
    return (
        <div
            ref={ref}
            className={classNames('InlineAlert', `InlineAlert--${type}`)}
            data-testid="Inline-Alert"
        >
            <div className="InlineAlert__colour"></div>
            <TextWithIcon
                Icon={(props) => <ToastIcon {...props} className="InlineAlert__icon" type={type} />}
            >
                {children}
            </TextWithIcon>
        </div>
    );
}
